/**
 * 表格默认配置
 */
const noop = function () {};

export default {
  pk: 'id',
  // 数据主键字段
  contextPath: '',
  // 根路径
  url: '',
  // 请求表格数据的后台接口, url和pagePath二选一必填
  pagePath: '',
  // 请求表格数据页面地址, url和pagePath二选一必填
  schemaUrl: '',
  // 查询 url，用于获取已保存的搜索方案列表
  schemaSaveUrl: '',
  // 保存 schema 的 url
  schemaDelUrl: '',
  // 删除 schema 的 url
  schemaType: '',
  // 搜索方案列表查询参数
  pageFlag: '',
  // 搜索方案列表查询参数
  action: '',
  // emap动作名
  datamodel: null,
  // 一般为emap返回的数据模型,
  beforeSend: noop,
  // 请求发送前的回调函数
  beforeSchemaRequest: noop,
  // 请求搜索方案前的回调函数
  defaultParams: false,
  // 查询请求默认附加参数
  onceParams: false,
  // 查询请求默认附加参数
  alwaysHide: ['WID', 'TBRQ', 'TBLX', 'CZRQ', 'CZZ', 'CZZXM'],
  // 自定义显示列的隐藏字段
  saveSchemaCallback: null // 保存列方案之后的回调

};